import { PropsWithChildren } from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "./AuthProvider"

/**
 * AdminRoute component protects routes that should only be accessible to corporate users
 * Redirects normal users to the dashboard
 */
export default function AdminRoute({ children }: PropsWithChildren) {
  const context = useAuth()

  if (!context) {
    return <Navigate to="/login" replace />
  }

  const { isCorporate, user } = context

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (!isCorporate) {
    return <Navigate to="/time-sheet/check" replace />
  }

  return <>{children}</>
}
